import { render, staticRenderFns } from "./AdresSelectableList.vue?vue&type=template&id=2c56b384"
import script from "./AdresSelectableList.vue?vue&type=script&lang=ts"
export * from "./AdresSelectableList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports